(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ozoric-buy-now"] && !Shopify.designMode) return;
  try {
    ;(async () => {
  const { StandardEvents } = await import('@shopify/events');
if (!customElements.get('ozoric-buy-now')) {
  customElements.define('ozoric-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.component = this.closest('product-form-component');
      this.button = this.querySelector('button');
      this.pending = false;
      if (!this.component || !this.button) return;
      const signal = this.controller.signal;
      this.button.addEventListener('click', () => this.start(), { signal });
      document.addEventListener(StandardEvents.cartLinesUpdate, event => this.complete(event), { capture: true, signal });
      document.addEventListener(StandardEvents.cartError, event => {
        if (this.pending && event.target === this.component) this.fail(true);
      }, { capture: true, signal });
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.reset();
      }, { signal });
      this.observer = new MutationObserver(() => this.syncAvailability());
      this.observer.observe(this.component, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
      this.syncAvailability();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timeout);
    }
    mainButton() { return this.component?.querySelector('[ref="addToCartButton"]'); }
    syncAvailability() {
      const disabled = this.pending || this.component?.getAttribute('aria-busy') === 'true' || !this.mainButton() || this.mainButton().disabled;
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
    }
    setBusy(busy) {
      this.button.setAttribute('aria-busy', String(busy));
      this.querySelector('[data-idle]').hidden = busy;
      this.querySelector('[data-busy]').hidden = !busy;
      this.syncAvailability();
    }
    reset() {
      clearTimeout(this.timeout);
      this.pending = false;
      this.querySelector('.oz-buy-now__status').hidden = true;
      this.setBusy(false);
    }
    start() {
      const addButton = this.mainButton();
      const form = this.closest('form');
      if (this.pending || this.component?.getAttribute('aria-busy') === 'true' || !addButton || addButton.disabled || !form?.reportValidity()) return;
      this.querySelector('.oz-buy-now__status').hidden = true;
      this.pending = true;
      this.setBusy(true);
      this.timeout = setTimeout(() => this.fail(true), 25000);
      addButton.click();
    }
    complete(event) {
      if (!this.pending || event.target !== this.component || event.action !== 'add') return;
      event.stopImmediatePropagation();
      event.promise?.then(({ detail }) => {
        if (!this.pending || String(detail?.productId) !== this.component.dataset.productId) return;
        if (detail?.didError) { this.fail(true); return; }
        clearTimeout(this.timeout);
        window.location.assign(this.dataset.checkoutUrl);
      }).catch(() => this.fail(true));
    }
    fail(uncertain) {
      clearTimeout(this.timeout);
      this.pending = uncertain;
      this.setBusy(false);
      const status = this.querySelector('.oz-buy-now__status');
      status.hidden = false;
      this.querySelector('[data-error]').hidden = uncertain;
      this.querySelector('[data-timeout]').hidden = !uncertain;
    }
  });
}
})().catch(error => console.error('Ozoric purchase controls could not initialize', error));
  } catch(e) { console.error(e); }
})();

})();
